import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { Currency } from 'modules/expenses/hooks/useExpensesListPage'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

type Props = BaseFilterProps & {
  currencies: Currency[]
}
const currencyFilter = ({
  currencies,
  expensesContext,
  initialFilterValues,
}: Props): DataTableFilter<ExpensesExpensableFilter> => {
  const options = [...currencies]
    .sort((cur1, cur2) => (cur1!.priority > cur2!.priority ? 1 : -1))
    .map((currency) => ({
      label: `${currency?.isoCode} - ${currency?.name}`,
      value: currency?.isoCode as string,
    }))

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
        value: initialFilterValues.currency ? [initialFilterValues.currency] : [],
      },
    ],
    onUpdateValue: () => {
      trackFilters('currency', expensesContext)
    },
    identifier: 'expensesList.currencyFilter',
    path: 'currency',
    title: i18n.t('expenses_v2.list.header.currency'),
    default: !!initialFilterValues.currency,
  }
}

export default currencyFilter
